
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { IUser } from "../../../utilities/interfaces";

/**
 * Users state declaration
 */
export interface Users {
  users: IUser[]
}

/**
 * Initial users state definition
 */
const initialState: Users = {
  users: []
};

/**
 * Users slice combining actions and reducer
 */
export const usersSlice = createSlice({
  name: "users",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<IUser[]>) => {
      state.users = action.payload;
    },
  },
});

export const {
 setUsers
} = usersSlice.actions;

// Other code such as selectors can use the imported `RootState` type

export const selectUser = (state: RootState) => state.users.users;

export default usersSlice.reducer;
